module.exports = __webpack_public_path__ + "img/gc_country_flag_si.15c79b87.svg";